import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { RadioDesigns } from '@shared/models';

@Component({
  selector: 'sd-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SdvorRadioComponent),
      multi: true,
    },
  ],
})
export class SdvorRadioComponent implements ControlValueAccessor {
  @Input() name: string;
  @Input() value: string;

  /**
   * В неактивном состоянии
   */
  @Input() @HostBinding('class.disabled') disabled = false;

  /**
   * Стиль радио кнопки
   */
  @Input() design: RadioDesigns = RadioDesigns.Circle;

  @ViewChild('input', { static: true }) inputRef: ElementRef;

  @HostBinding('class')
  get classNames(): string[] {
    return ['radio', `radio-design-${this.design}`];
  }

  actualValue: string;

  private onChange: (_: any) => void;
  private onTouched: (_: any) => void;

  writeValue(value: string): void {
    this.actualValue = value;
    if (this.value === this.actualValue) {
      this.inputRef.nativeElement.checked = true;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  inputOnChange(value: string): void {
    this.onChange(value);
    this.onTouched(value);
  }
}
